import React from "react";
import { InlineStack, Tooltip, Icon } from "@shopify/polaris";
import { InfoIcon } from "@shopify/polaris-icons";

/**
 * Field label plus compact “i” icon; full help text on hover (Polaris Tooltip).
 * @param {React.ReactNode} [label] — string or node shown as the visible label
 * @param {string} [tooltip] — when omitted, returns `label` only (no icon)
 */
export function LabelWithTooltip({ label, tooltip }) {
  if (!tooltip) {
    if (typeof label === "string" || typeof label === "number") {
      return <span>{label}</span>;
    }
    return label;
  }
  const labelContent =
    typeof label === "string" || typeof label === "number" ? <span>{label}</span> : label;
  return (
    <InlineStack gap="100" blockAlign="center" wrap={false}>
      {labelContent}
      <Tooltip content={tooltip} preferredPosition="above" width="wide">
        <button
          type="button"
          className="age-label-tooltip-trigger"
          aria-label="More information"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
            margin: 0,
            border: "none",
            background: "transparent",
            cursor: "pointer",
            verticalAlign: "middle",
          }}
        >
          <Icon source={InfoIcon} tone="subdued" />
        </button>
      </Tooltip>
    </InlineStack>
  );
}
